import { type CartSellerGroupsV2 } from '@redteclab/api/clients/bully'

export const getLinePercentAffectedProductIds = (
  sellerGroup: CartSellerGroupsV2
) => [
  ...new Set(
    (sellerGroup.discounts ?? [])
      .filter(
        // only "linePercent" is supported at the moment
        groupDiscount => groupDiscount.promotionType === 'linePercent'
      )
      .map(groupDiscount => groupDiscount.affectedProductIds ?? [])
      .flat()
  ),
]
